<template>
  <van-popup v-model="showPicker" round position="bottom">
    <div class="apply-pop">
      <div class="pop-title">
        <i class="close-icon" @click="showPicker = false"></i>
        <p>审核人</p>
        <i class="confirm-icon" @click="done"></i>
      </div>
      <div class="person">
        <button class="per-btn" ref="person" @click="personTap($event, index)" v-for="(item, index) in userList" :key="item.userid">
          {{ item.userrealname }}
        </button>
      </div>
    </div>
  </van-popup>
</template>

<script>
import  iApi  from '@/utils/internship'
export default {
  props: {
    code: {
      type: Number,
      default: 667,
    },
  },
  data() {
    return {
      showPicker: false,
      userList: [
        {
          useraccount: '',
          useremail: '',
          userid: '',
          userrealname: '全部',
          isBtn: 0,
        },
      ],
    }
  },
  methods: {
    async open() {
      if(this.code == '966' || this.code == '670' || this.code == '965'){
        this.userList = [];
      }
      if (this.userList.length < 2) {
        const res = await iApi.getReviewer({ ywcode: this.code })
        this.userList = this.userList.concat(res.data)
        this.userList.forEach((item, index) => {
          this.userList[index].isBtn = 0
        })
      }
      this.showPicker = true
    },
    personTap(e, res) {
      let strList = []
      let idList = []
      if (this.userList[res].isBtn == 0) {
        this.userList[res].isBtn = 1
        e.target.className = 'cur'
      } else if (this.userList[res].isBtn == 1) {
        this.userList[res].isBtn = 0
        e.target.className = 'per-btn'
      }
      for (let i in this.userList) {
        if(this.code != '966' && this.code != '670' && this.code != '965'){
          if (this.userList[res].userrealname == '全部') {
            this.userList[i].isBtn = 0
            this.userList[res].isBtn = 1
            this.$refs.person[res].className = 'cur'
            this.$refs.person[i].className = 'per-btn'
          } else {
            this.userList[0].isBtn = 0
            this.$refs.person[0].className = 'per-btn'
          }
        }
        
        if (this.userList[i].isBtn == 1) {
          strList = strList.concat(this.userList[i].userrealname)
          idList = idList.concat(this.userList[i].userid)
        }
      }
      // this.fsForm.userid = idList.toString();
      this.$emit('change', idList.toString())
    },
    done(){
      this.$emit('done')
      this.showPicker = false
    }
  },
}
</script>

<style lang="less" scoped>
.apply-pop {
  width: 100%;
  position: fixed;
  bottom: 0;
  background-color: @attendance-color-3;
  box-sizing: border-box;
  border-radius: 5px 5px 0 0;
  max-height: 40%;
  overflow-y: scroll;
}
.close-icon {
  background: url(../../../../../../static/img/close.png) no-repeat center;
}
.pop-title {
  display: flex;
  justify-content: space-between;
  padding: 13px;
  position: fixed;
  width: 100%;
  background-color: @attendance-color-3;
  box-sizing: border-box;
  border-radius: 5px 5px 0 0;
  z-index: 9;
}
.pop-title i {
  width: 22px;
  height: 22px;
  background-size: 22px 22px;
}
.confirm-icon {
  background: url(../../../../../../static/img/confirm.png) no-repeat center;
}
.person {
  padding: 20px 20px 0;
  display: flex;
  flex-wrap: wrap;
  margin-top: 48px;
}
.person button {
  border-radius: 3px;
  padding: 5px 15px;
  margin-right: 12px;
  margin-bottom: 15px;
}
.apply-pop .person .per-btn {
  background-color: @attendance-background-color-7;
  color: @attendance-background-color-1;
}
.person .cur {
  background-color: @attendance-background-color-1;
  color: @attendance-background-color-7;
}
</style>



// WEBPACK FOOTER //
// src/components/newPages/student/internship/components/reviewerDialog.vue